var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-setting"},[_c('edit',{attrs:{"fs":_vm.useChatFields,"api":"settings","id":"use-chat","title":"Use Chat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }